import { Handle, Position } from '@xyflow/react';
import { useState } from 'react';
import './index.scss';
import { NODE_TYPE } from '../../constants';
import { Tooltip } from 'antd';
import atoms from '@/styles/atoms.module.scss';

export const NODE_TYPE_ICON = {
  [NODE_TYPE.CUSTOM_NODE]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
      />
    </svg>
  ),
  [NODE_TYPE.START]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  ),
  [NODE_TYPE.LLM]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
      />
    </svg>
  ),
  [NODE_TYPE.KNOWLEDGE]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
      />
    </svg>
  ),
  [NODE_TYPE.CONDITION]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
      />
    </svg>
  ),
  [NODE_TYPE.PG]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
      />
    </svg>
  ),
  [NODE_TYPE.END]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`size-6 ${atoms.iconPrimary}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
      />
    </svg>
  ),
};

// =================== 自定义节点 ===================
type CustomNodeProps = {
  id: string;
  type: NODE_TYPE;
  data: {
    label: string;
    onHandleClick?: (e: React.MouseEvent, nodeId: string, handleType: string) => void;
    onDeleteNode?: (nodeId: string) => void;
    [key: string]: any;
  };
};

export const CustomNode: React.FC<CustomNodeProps> = ({ id, type, data }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClick = (event: React.MouseEvent) => {
    // 调用传入的点击处理函数
    if (data.onClick) {
      data.onClick(event);
    }
  };
  return (
    <div
      className="group relative pb-1 shadow-xs rounded-[15px] border border-transparent w-[240px] bg-workflow-block-bg hover:shadow-lg !border-state-success-solid"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      onClick={handleClick}
    >
      <div className={`${atoms.textStandard} flex flex-col space-y-2 rounded-t-2xl px-3 pb-2 pt-3`}>
        <div className="font-medium flex items-center gap-2">
          {' '}
          {NODE_TYPE_ICON[type]}
          {data.label}
        </div>
        {data.branches && <div></div>}
        {data.systemPrompt && <div className="line-clamp-2 ">{data.systemPrompt}</div>}
      </div>
      {showMenu && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className={`size-5 absolute right-[-6px] top-[-6px] cursor-pointer ${atoms.textDanger}`}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            data.handleDeleteNode(id);
          }}
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z"
            clipRule="evenodd"
          />
        </svg>
      )}

      {/* 左侧输入桩 */}
      {type !== NODE_TYPE.START && (
        <Handle type="target" position={Position.Left} style={{ background: '#555' }} />
        // <Handle type="target" id="input" position={Position.Left} style={{ background: '#555' }} />
      )}

      {/* 右侧输出桩 */}
      <Tooltip
        title={
          <>
            点击添加节点
            <br />
            拖拽连接节点
          </>
        }
      >
        <Handle
          type="source"
          // id="output"
          position={Position.Right}
          style={{ width: 8, height: 8, background: 'var(--color-primary)' }}
          onClick={e => data.onHandleClick?.(e, id, 'source')}
        />
      </Tooltip>
    </div>
  );
};
